import React from 'react'
import { Button, Navbar } from 'react-bootstrap'

import './NavigationBar.scss'

const NavigationBar = props => {
  return (
    <Navbar
      className={`navbar navbar-expand-md bg-white intake-title-bar ${
        props.isInline === 'sticky' ? 'sticky-navigation-bar' : ''
      }`}
      fixed={props.isInline === 'sticky' || props.isInline === true ? undefined : 'top'}
    >
      <div className="container">
        <div className="w-100">
          <ul className="navbar-nav mr-auto">
            {props.leftBtnText && (
              <Button variant="link" id="leftBtn" onClick={props.handleClickLeft}>
                {props.leftBtnText}
              </Button>
            )}
          </ul>
        </div>
        <div className="mx-auto">
          <li className="navbar-brand font-weight-bold"> {props.title} </li>
        </div>
        <div className="navbar-collapse collapse w-100">
          <ul className="navbar-nav ml-auto">
            {props.extraRightContent && (
              <li className="nav-item d-flex align-items-center mr-2">{props.extraRightContent}</li>
            )}
            {props.rightBtnSecondaryText && (
              <Button
                id="rightBtnSecondary"
                className="action-button secondary mr-3"
                variant="link"
                onClick={props.handleClickRightSecondary}
              >
                {props.rightBtnSecondaryText}
              </Button>
            )}
            {props.rightBtnText && (
              <Button id="rightBtn" className="action-button" variant="link" onClick={props.handleClickRight}>
                {props.rightBtnText}
              </Button>
            )}
          </ul>
        </div>
      </div>
    </Navbar>
  )
}

export default NavigationBar
